import styled from 'styled-components'

export const StylizedCalendarWrapper = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.zds.colors.neutral1000};
  border-radius: 4px;
  border: 2px solid ${props => props.theme.colors.color378ff7};
  border-top-width: 0.8rem;
`
